<template>
    <v-menu
        ref="menu"
        v-model="showMenu"
        v-bind:close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                filled
                v-bind:value="value"
                v-bind:label="label"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker v-model="datepickerDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" v-on:click="showMenu = false">
                Cancel
            </v-btn>
            <v-btn text color="primary" v-on:click="onDateChanged">
                OK
            </v-btn>
        </v-date-picker>
    </v-menu>
</template>

<script>
export default {
    props: {
        value: {
            type: String
        },
        label: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showMenu: false,
            selectedDate: new Date()
        };
    },
    computed: {
        // Date picker accepts yyyy-MM-dd format
        // Set value to a temporary field to emit it
        datepickerDate: {
            get() {
                return this.$options.filters.date(
                    new Date(this.value),
                    'yyyy-MM-dd'
                );
            },
            set(value) {
                this.selectedDate = value;
            }
        }
    },
    methods: {
        onDateChanged() {
            this.$refs.menu.save(this.selectedDate);
            this.$emit('input', this.selectedDate);
        }
    }
};
</script>
